import { createSelector } from 'reselect';
import getOrdering from './getOrdering';

const getMinimumOrderInclusive = createSelector(
  [getOrdering],
  (ordering: OrderingState) => Boolean(ordering.config.includeDiscountMinSpend),
);

export default getMinimumOrderInclusive;
